module.exports = __webpack_public_path__ + "img/bg-mision-2-16.ec0dba40.jpg";